import MathHtml from 'components/imported-assessment/MathHtml'
import update from 'immutability-helper'
import {zip} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'

import Select from '@mui/material/Select'

import {shuffleArray} from '../../../../helpers/utils'

const useStyles = makeStyles(matchingStyles)

export default function Matching ({context, question}) {

  const classes = useStyles()
  const {translate} = context

  const {choices, assignDefinition} = useChoices(question.answer.choices || [])

  const terms = choices.terms.map(({term, id}, index) => {

    const value = choices.selected[index]
    const correctIndex = choices.definitions.findIndex (d => d.id == id)
    const answerIndex = String.fromCharCode(Math.min(correctIndex, 20) + 97)

    const cleared = value == -1
    const correct = correctIndex == value
    const incorrect = !cleared && correctIndex != value

    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.selectAnswer)} size="small">
        <SelectDefinition
          index={index}
          definitions={choices.definitions}
          value={choices.selected[index]}
        />
      </TableCell>
      {context.importedMath ? <TableCell className={clsx(classes.cell, classes.termHtml)}><MathHtml html={term || ''} /></TableCell> : <TableCell className={clsx(classes.cell, classes.termHtml)} dangerouslySetInnerHTML={{__html: term || ''}} />}
    </React.Fragment>)
  })

  const definitions = choices.definitions.map(({definition}, index) => {
    const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.definitionIndex, {selected: choices.selected.indexOf(index) > -1})} size="small">
        {answerIndex})
      </TableCell>
      {context.importedMath ? <TableCell className={clsx(classes.cell, classes.definitionValue)}><MathHtml html={definition || ''} /></TableCell> : <TableCell className={clsx(classes.cell, classes.definitionValue)} dangerouslySetInnerHTML={{__html: definition || ''}} />}
    </React.Fragment>)
  })

  return (
  <Box className={classes.root}>
    <TableContainer component={Box} className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableBody>{
          zip(terms, definitions).map(([term, definition], index) => {
            return (
              <TableRow key={index} className={classes.pair}>
                {term}
                {definition}
              </TableRow>
            )
          })}</TableBody>
     </Table>
   </TableContainer>
  </Box>
  )
}

function useChoices(choices) {

  const [state, setState] = React.useState({
    definitions: [],
    terms: [],
    selected: []
  })

  React.useEffect(() => {
    if (choices) {
      const terms = shuffleArray(choices.map(([term, _, id], index) => ({id, term, index})))
      const definitions = shuffleArray(choices.map(([_,definition,id], index) => ({id, definition, index})))
      const selected = terms.map(({id}) => definitions.findIndex(d => d.id == id))
      setState({terms, definitions, selected})
    }
  }, [choices])

  function assignDefinition(term, definition) {

    const selected = update(state.selected, {
        [state.selected.indexOf(definition)]: {$set: -1},
        [term]: {$set: definition},
    })

    setState(update(state, {
        selected: {$set: selected}
    }))

  }

  return {choices: state, assignDefinition}

}

function SelectDefinition (props) {

  const classes = useStyles()

  return (
    <Select
      className={classes.termValue}
      value={props.value}
      readOnly
    >
      <MenuItem style={{display: 'none'}} value={-1}> </MenuItem>
      {props.definitions.map((definition, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <MenuItem key={index} value={index}>{answerIndex}</MenuItem>
        )
      })}
    </Select>
  )
}

function matchingStyles (theme) {
  return {
    root: {
      display: 'flex',
      marginTop: 10,
      flexGrow: 1
    },
    tableContainer: {
      flexShrink: 0,
      maxWidth: 1280,
      display: 'flex',
      fontSize: '12pt',
    },
    cell: {
      borderBottom: 0,
      padding: '16px 8px',
      verticalAlign: 'top'
    },
    correctAnswer: {
      width: 35,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 35
    },
    selectAnswer: {
      width: 45,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 45,
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      }
    },
    definitionIndex: {
      width: 20,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 20
    },
    table: {
      maxWidth: 1280
    },
    term: {
      display: 'flex'
    },
    termValue: {
      border: 'solid 1px #e0e5e9',
      borderRadius: 3,
      paddingLeft: 8,
      justifyContent: 'center',
      '&:focus': {
        backgroundColor: 'transparent'
      },
      '&:before' : {
        borderBottom: '0 !important'
      },
      '&:after': {
        borderBottom: 0
      }
    },
    termHtml: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    },
    definitionValue: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    }
  }
}
